export default __webpack_public_path__ + "static/PlayfairDisplay-Regular-89aeb04deaf54df2b9e0d901fd1f0a51.woff";